var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M3.5 7H24.5",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#FD2D23"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M22.1667 7V23.3333C22.1667 23.9522 21.9208 24.5457 21.4833 24.9832C21.0457 25.4208 20.4522 25.6667 19.8333 25.6667H8.16667C7.54783 25.6667 6.95434 25.4208 6.51675 24.9832C6.07917 24.5457 5.83333 23.9522 5.83333 23.3333V7",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#FD2D23"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M9.33333 7V4.66667C9.33333 4.04783 9.57917 3.45434 10.0168 3.01675C10.4543 2.57917 11.0478 2.33333 11.6667 2.33333H16.3333C16.9522 2.33333 17.5457 2.57917 17.9832 3.01675C18.4208 3.45434 18.6667 4.04783 18.6667 4.66667V7",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#FD2D23"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M11.6667 12.8333V19.8333",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#FD2D23"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M16.3333 12.8333V19.8333",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#FD2D23"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrash);
export default __webpack_public_path__ + "static/media/trash.ff25f5d3d24cb15c097b685db13771cb.svg";
export { ForwardRef as ReactComponent };